module.exports = __webpack_public_path__ + "img/2.5fe3c915.png";